<div class="flex w-full items-center justify-center gap-24 top">
  <app-home-user-banner [user]="sessionService.profile()" />
  <app-home-slides [user]="sessionService.profile()"></app-home-slides>
</div>
<app-home-games class="games" />
<app-live-bets-table class="live-bets" [bets]="liveBetsService.liveBets()" />
